import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wz-form-group-header',
  templateUrl: './form-group-header.component.html',
  styleUrls: ['./form-group-header.component.scss'],
  standalone: false,
})
export class FormGroupHeaderComponent implements OnInit {
  ngOnInit(): void {}
}
